let retryTimes = 3;

export function retryGetAdjustId(cb: (id: string) => void): void {
  setTimeout(() => {
    const adjustId = window.Adjust?.getAttribution?.()?.adid;
    if (adjustId) {
      cb(adjustId);
      // 获取成功重置重试次数
      retryTimes = 3;
      return;
    }
    if (retryTimes > 0) {
      retryGetAdjustId(cb);
      retryTimes--;
    } else {
      // 寿命获取不到
      cb("");
    }
  }, 100);
}
